


interface OrderReducedIconProps {
	className?: string,
}


const OrderReducedIcon = (props: OrderReducedIconProps) => {
	const { className } = props;

	return (
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="custom-order-reduced-icon"
			className={`svg-inline--fa fa-custom-order-reduced-icon${className ? ` ${className}` : ''}`}
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 334 512">
			<path fill="currentColor" d="m98.07,80.78c3.99,-23.24 21.61,-40.11 41.89,-40.11l48.08,0c20.3,0 37.92,16.91 41.89,40.19l3.6,21.19l40.59,0l-4.75,-27.91c-7.27,-42.58 -41.48,-73.48 -81.33,-73.48l-48.08,0c-39.84,0 -74.02,30.85 -81.31,73.36l-4.81,28.03l40.59,0l3.65,-21.27l-0.01,0z"/>
			<path fill="currentColor" d="m257.4,228.76l31.91,26.57l-113.83,41.92l20.61,-119.54l31.27,26.04l71.19,-85.49c1.48,-1.87 2.95,-3.73 4.43,-5.6c-2.01,-0.35 -4.04,-0.62 -6.15,-0.62l-260.09,0c-20.01,0 -36.28,16.27 -36.28,36.28l0,327.4c0,0.72 0.02,1.44 0.07,2.15l71.81,-86.52l-31.95,-26.52l113.77,-42.1l-20.42,119.57l-31.31,-25.99l-77.69,93.6c3.76,1.34 7.8,2.09 12.01,2.09l260.09,0c20.01,0 36.28,-16.27 36.28,-36.28l0,-327.4c0,-3.14 -0.42,-6.17 -1.19,-9.06l-74.53,89.5z"/>
		</svg>
	);
};

export default OrderReducedIcon;